
import AuthService from "@/services/AuthService";
import NavigationService from "@/services/NavigationService";
import { defineComponent } from "vue";
import GlobalStore from "@/utils/global-store";
import Alert from "@/components/Alert.vue";

export default defineComponent({
    name: 'AuthShroud',
    components: {
        Alert
    },
    props: {
        redirect: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    computed: {
        loggedIn() {
            return GlobalStore.data.loggedIn.value;
        },
        userRole() {
            return GlobalStore.data.userRole.value;
        },
        authFailed() {
            return GlobalStore.data.authFailed.value;
        },
    },
    data() {
        return {
            loading: true,
            redirectAllowed: false, // redirect only after check in this component was done
        };
    },
    methods: {
        redirectIfRequired() {
            if( !this.loggedIn && this.redirectAllowed && this.redirect ) {
                NavigationService.navigateMissingAuth();
            }
        },
        testAuth() {
            this.loading = true;
            return AuthService.getAuthUser().then(result => {
                if( result.data.data.role || result.data.data.role === 0 ) {
                    GlobalStore.set({
                        userRole: result.data.data.role,
                    });
                }
            }).finally(() => {
                this.loading = false;

                this.redirectAllowed = true;

                this.redirectIfRequired();
            });
        },

        performLogout() {
            (window as any).buggyFitLogout();
            setTimeout(() => {
                NavigationService.navigateLogoutSuccessful();
            }, 1000);
        }
    },
    watch: {
        loggedIn() {
            this.redirectIfRequired();
        },
    },
    mounted() {
        this.testAuth();
    },
});
